export default __webpack_public_path__ + "static/media/modal_frame_header_logo.7df009ba.png";